export { GradientPicker } from './component';
export type { GradientPickerProps } from './types';
